// extracted by mini-css-extract-plugin
module.exports = {"container":"container--Mz_5u","block":"block--3UCAB","icon":"icon--RSIt5","block-title":"block-title--1TB9W","block-message":"block-message--1MOc1"};